export const SITE_NAME = "Mutual of Omaha Mortgage Complaint Dossier";
export const SITE_URL =
  (process.env.REACT_APP_SITE_URL || "https://mutualmortgagee.com").replace(
    /\/+$/,
    ""
  );
export const SITE_DESCRIPTION =
  "Source-backed public dossier covering a CFPB mortgage complaint about two 700 N Dupont Ave loans, Mutual of Omaha Mortgage's response, and the complainant's rebuttal.";
export const DEFAULT_ROBOTS =
  process.env.REACT_APP_ROBOTS ||
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
export const DEFAULT_SOCIAL_IMAGE_PATH = "/icon.svg";

export function buildAbsoluteUrl(path = "/") {
  if (!path) {
    return SITE_URL;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
